<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5 class="pt-2">Estimate Notes (internal only, will not display on estimate)<button type="button" class="close"
                                                         @click.prevent="closeModal()">
        <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid">
        <div class="justify-center align-center">
        <div class="row justify-center align-center mt-2 pb-2 header-row orange note-header-row" >
          <div class="col-1"></div>
          <div class="col-3">Note</div>
          <div class="col-3">User</div>
          <div class="col-4">Date</div>
          <div class="col-1"></div>
        </div>
          <div v-for="note in notes" :key="note.organizationPatientEstimateNoteId" class="row data-row pb-3 ">
            <div class="col-1"></div>
            <div class="col-3">{{note.note }}</div>
            <div class="col-3">{{ note.userLastName }}, {{ note.userFirstName }}</div>
            <div class="col-4">{{ formatDate(note.createdAt) }}</div>
            <div class="col-1"></div>
        </div>
        </div>
        <div class="row">
          <div class="col">
            <hr/>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8 mt-3">
            <b-form-group :label-cols="4"
                          label="Add Estimate Note"
                          label-class="text-right"
                          :state="stateForField('note')"
                          :invalid-feedback="errorForField('note')">
            <b-textarea v-model="newNote.note"></b-textarea>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="saveNote()"><font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner"  pulse/>Save</button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import api from '@/services/api'
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import moment from 'moment-timezone'

  export default {
    name: 'EstimateInternalNotesModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      id: {
        default: 0
      }
    },

    data () {
      return {
        notes: [],
        newNote: {},
        isSaving: false
      }
    },

    methods: {
      loadData () {
        api.get('Dashboard/Estimate/' + this.id + '/Notes').then(response => {
          this.notes = response.data
          this.$emit('updated', this.notes)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load estimate notes: ' + error.message, error)
            this.addErrorForField('exception', error.message)
          }
        })
        this.newNote = {}
      },

      formatDate (date) {
        if (date) {
          return moment(date).format('MM/DD/YYYY h:mm a')
        } else {
          return ''
        }
      },

      validate () {
        this.clearAllErrors()

        if (!this.newNote.note) {
          this.addErrorForField('note', 'You must enter a note')
        }

        return !this.hasErrors()
      },

      saveNote () {
        if (!this.validate()) {
          return
        }
        if (this.isSaving === true) {
          return
        }
        this.isSaving = true

        this.newNote.organizationPatientEstimateId = this.id

        api.post('Dashboard/Estimate/' + this.estimateId + '/Notes', this.newNote).then(response => {
          this.loadData()
          this.isSaving = false
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        })
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    },

    watch: {
      visible (newValue) {
        if (newValue) {
          this.loadData()
        }
      }
    },

    created () {
      this.loadData()
    }
  }
</script>

<style scoped>

.note-header-row {
  font-weight: bold;
}

</style>
